import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/Overlay";

interface IWebsiteBuilderHelpIconProps {
  id: string;
  message: string;
  placement: Placement;
}

export function WebsiteBuilderHelpIcon(props: IWebsiteBuilderHelpIconProps) {
  const { id, message, placement } = props;
  
  return (
    <OverlayTrigger
      placement={placement}
      delay={{
        show: 500,
        hide: 100,
      }}
      overlay={
        <Tooltip id={id}>
          {message}
        </Tooltip>
      }
    >
      <FontAwesomeIcon icon={faCircleQuestion} />
    </OverlayTrigger>
  );
}
